import React, { useCallback, useState } from 'react';
import p from '../../styles/renewal/OnePage.module.css';
import { PARTNER_STEPS, PARTNER_TYPES } from './data';
import { noTranslate } from './formatters';
import PartnerForm from './PartnerForm';

const Partner = () => {
  const [formOpen, setFormOpen] = useState(false);
  const closeForm = useCallback(() => setFormOpen(false), []);

  return (
    <section className={`${p.bleed} ${p.reveal}`}>
      <div className={p.bleedInner}>
        <div className={p.headRow}>
          <div>
            <div className={p.badge} translate="no">PARTNERSHIP</div>
            <h2 className={p.title}>오퍼그룹과 함께할 제휴 파트너를 모집합니다.</h2>
            <p className={p.lead} translate="no">
              구매와 도입이 필요한 기업고객을 연결해 주시거나, 오퍼그룹의 BNPL 솔루션을 함께 제공할
              파트너를 상시 모집합니다.
            </p>
          </div>
          <button
            type="button"
            className={`${p.btn} ${p.btnPrimary}`}
            onClick={() => setFormOpen(true)}
          >
            제휴 신청하기
          </button>
        </div>

        <div className={p.grid4}>
          {PARTNER_TYPES.map((item) => (
            <div className={p.cardSoft} key={item.no}>
              <div className={`${p.numSq} ${p.numSqSm}`}>{item.no}</div>
              <div className={p.partnerTitle}>{item.title}</div>
              <p className={p.partnerText} translate={noTranslate(item.body)}>{item.body}</p>
            </div>
          ))}
        </div>

        <PartnerForm open={formOpen} onClose={closeForm} />

        <h2 className={`${p.titleSm} ${p.partnerStepsTitle}`}>제휴 절차</h2>

        <div className={p.gridSteps}>
          {PARTNER_STEPS.map((step) => (
            <div className={p.cardPlain} key={step.no}>
              <div className={p.numDot}>{step.no}</div>
              <div className={p.partnerStepTitle}>{step.title}</div>
              <p className={p.stepText}>{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partner;
